import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function TeamConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const team = location.state?.team;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!team) {
    return (
      <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
        <p className="text-lg">No details found. Please register first.</p>
      </div>
    );
  }

  const handleConfirm = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/teams/register`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(team),
        },
      );
      const data = await res.json();
      if (res.ok) {
        navigate("/coach", { state: { teams: data } });
      } else {
        setError(data.error || "Registration failed");
      }
    } catch (err) {
      setError("Could not reach server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-5 w-full max-w-sm space-y-3 text-center">
        <h1 className="text-xl font-bold text-brand-red">
          Confirm Your Details
        </h1>

        <div className="text-left space-y-1 text-base">
          <p>
            <strong>Coach:</strong> {team.coachName}
          </p>
          <p>
            <strong>County / Area:</strong> {team.county}
          </p>
          <p>
            <strong>Phone:</strong> {team.phone}
          </p>
          <p>
            <strong>Email:</strong> {team.email}
          </p>
        </div>

        {error && <p className="text-red-600 text-sm">{error}</p>}

        <button
          onClick={handleConfirm}
          disabled={loading}
          className="w-full bg-brand-red text-white font-bold text-base py-2.5 rounded-lg hover:bg-red-800 disabled:opacity-50"
        >
          {loading ? "Creating account..." : "Confirm & Continue"}
        </button>

        <button
          onClick={() => navigate("/")}
          className="w-full text-sm text-gray-500 underline"
        >
          Go back and edit
        </button>
      </div>
    </div>
  );
}

export default TeamConfirmation;